import React from 'react'
import { string, node, arrayOf, oneOfType, element, shape, func } from 'prop-types'

import classNames from 'src/common/helpers/class-names'

import Header from './header'
import Main from './main'
import Item from './item'

const ProductList = (props = {}) => {
  const {
    className, children, type, title, mods, items, handleFavouriteClick, handleProductClick, ...rest
  } = props
  const blk = 'co-product-list'
  const baseClass = classNames({ blk })
  const listClass = `${className} ${baseClass}`
  return (
    <div className={listClass} data-type={type}>
      <Header title={title} mix={className} />
      <Main mix={className} mods={mods}>
        {items.map((item, index) => {
          const { id } = item
          return id ? (
            <Item
              {...rest}
              key={id}
              item={item}
              index={index}
              handleFavouriteClick={handleFavouriteClick}
              handleProductClick={handleProductClick}
            />
          ) : null
        })}
        {children}
      </Main>
    </div>
  )
}

ProductList.propTypes = {
  className: string,
  children: node,
  type: string,
  title: oneOfType([string, element]),
  mods: arrayOf(string),
  items: arrayOf(shape({})),
  handleFavouriteClick: func,
  handleProductClick: func,
  commonItemUrlQueryParam: string,
}

ProductList.defaultProps = {
  className: '',
  children: null,
  type: null,
  title: '',
  mods: [],
  items: [],
  handleFavouriteClick: () => {},
  handleProductClick: () => {},
  commonItemUrlQueryParam: '',
}

export default ProductList



// WEBPACK FOOTER //
// ./shared/interim/product-list/default-layout.js